import React from 'react';

const Demo = () => {
    return (
        <section className="py-16 relative overflow-hidden bg-white" id="demo">
            {/* Subtle background elements */}
            <div className="absolute inset-0 bg-gradient-to-b from-gray-50 via-white to-gray-50 opacity-70"></div>
            <div className="absolute top-40 left-10 w-72 h-72 bg-secondary/5 rounded-full blur-3xl"></div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <h2 className="text-5xl font-bold mb-6 text-secondary">
                        Prueba Nuestro Demo
                    </h2>
                    <p className="text-xl text-gray-600 mb-12">
                        Explora cómo Grovi puede transformar la experiencia digital de tu negocio
                    </p>
                </div>

                {/* Demo section */}
                <div className="bg-gray-50 rounded-2xl p-8 mb-24">
                    <div className="grid md:grid-cols-[1fr_1fr] gap-12 items-start">
                        {/* Left column: Desktop iframe - Main page */}
                        <div className="text-center flex flex-col items-center">
                            <h2 className="text-2xl font-bold mb-4 text-secondary">Página Principal</h2>
                            <div className="browser-mockup w-full max-w-[1000px]">
                                <div className="browser-bar">
                                    <div className="browser-controls">
                                        <span className="browser-control red"></span>
                                        <span className="browser-control yellow"></span>
                                        <span className="browser-control green"></span>
                                    </div>
                                    <div className="browser-address">
                                        <span>demo.grovi.com.uy</span>
                                    </div>
                                </div>
                                <div className="browser-content">
                                    <iframe
                                        src="https://demo.grovi.com.uy"
                                        title="Demo website desktop view"
                                        className="browser-iframe"
                                        loading="lazy"
                                        sandbox="allow-scripts allow-same-origin"
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                        {/* Right column: Mobile preview - Booking process */}
                        <div className="text-center flex flex-col items-center">
                            <h2 className="text-2xl font-bold mb-4 text-secondary">Sistema de Reservas</h2>
                            <div className="flex justify-center">
                                <div className="phone-mockup w-full max-w-[600px]">
                                    <div className="phone-frame">
                                        {/* Phone notch and hardware elements */}
                                        <div className="phone-notch">
                                            <div className="phone-speaker"></div>
                                            <div className="phone-camera"></div>
                                        </div>

                                        {/* Screen content - booking page */}
                                        <div className="phone-screen">
                                            <iframe
                                                src="https://demo.grovi.com.uy/booking"
                                                title="Demo booking page preview"
                                                className="phone-iframe"
                                                loading="lazy"
                                                sandbox="allow-scripts allow-same-origin"
                                            ></iframe>
                                        </div>

                                        {/* Home indicator */}
                                        <div className="phone-home-indicator"></div>
                                    </div>
                                    <div className="phone-shadow"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-center mt-12">
                        <div className="flex flex-col sm:flex-row justify-center gap-4">
                            <a
                                href="https://demo.grovi.com.uy"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center px-6 py-3 bg-secondary text-white font-semibold rounded-lg transition-all duration-300 hover:bg-secondary-dark shadow-md"
                            >
                                Ver Sitio Web Demo
                                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                </svg>
                            </a>
                            <a
                                href="https://demo.grovi.com.uy/booking"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center px-6 py-3 bg-primary text-white font-semibold rounded-lg transition-all duration-300 hover:bg-primary-dark shadow-md"
                            >
                                Probar Sistema de Reservas
                                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>

                {/* CTA */}
                <div className="text-center">
                    <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
                        Proyecta una imagen profesional y moderna con un sitio web personalizado para tu negocio
                    </p>
                    <a href="https://wa.me/59892748021?text=Hola!%20Me%20interesa%20tener%20una%20página%20web%20como%20las%20del%20demo%20para%20mi%20negocio" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-8 py-4 bg-primary text-white font-semibold rounded-lg transition-all duration-300 hover:bg-primary-dark shadow-lg">
                        Quiero una página como estas
                        <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                        </svg>
                    </a>
                </div>
            </div>

            {/* Device mockup styling */}
            <style jsx="true">{`
                /* Browser mockup */
                .browser-mockup {
                    border-radius: 8px;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
                    overflow: hidden;
                    max-width: 100%;
                    background: white;
                }
                
                .browser-bar {
                    background: #f1f3f5;
                    padding: 8px 12px;
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #e9ecef;
                }
                
                .browser-controls {
                    display: flex;
                    gap: 6px;
                    margin-right: 16px;
                }
                
                .browser-control {
                    width: 12px;
                    height: 12px;
                    border-radius: 50%;
                }
                
                .browser-control.red { background-color: #ff5f56; }
                .browser-control.yellow { background-color: #ffbd2e; }
                .browser-control.green { background-color: #27c93f; }
                
                .browser-address {
                    flex: 1;
                    background: white;
                    border-radius: 4px;
                    padding: 4px 12px;
                    font-size: 14px;
                    color: #495057;
                    text-align: center;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                
                .browser-content {
                    height: 500px;
                    overflow: hidden;
                }
                
                .browser-iframe {
                    width: 100%;
                    height: 100%;
                    border: none;
                }
                
                /* Phone mockup */
                .phone-mockup {
                    position: relative;
                    max-width: 100%;
                    margin: 0 auto;
                    transform: perspective(1000px);
                    transition: all 0.5s ease;
                }
                
                .phone-frame {
                    position: relative;
                    width: 100%;
                    height: 700px;
                    background: #121212;
                    border-radius: 40px;
                    padding: 12px;
                    overflow: hidden;
                    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
                    border: 6px solid #2d2d2d;
                    min-width: 320px;
                    max-width: 90vw;
                }
                
                /* Wider phone on small screens */
                @media (max-width: 767px) {
                    .phone-mockup {
                        width: 80vw;
                        max-width: 450px;
                    }
                    
                    .phone-frame {
                        width: 100%;
                        max-width: 100%;
                    }
                }
                
                .phone-notch {
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 150px;
                    height: 30px;
                    background: #121212;
                    border-bottom-left-radius: 20px;
                    border-bottom-right-radius: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 10;
                }
                
                .phone-speaker {
                    width: 60px;
                    height: 6px;
                    background: #2d2d2d;
                    border-radius: 3px;
                }
                
                .phone-camera {
                    position: absolute;
                    right: 30px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 10px;
                    height: 10px;
                    background: #2d2d2d;
                    border-radius: 50%;
                }
                
                .phone-screen {
                    width: 100%;
                    height: 100%;
                    background: white;
                    border-radius: 30px;
                    overflow: hidden;
                    position: relative;
                }
                
                .phone-iframe {
                    width: 100%;
                    height: 100%;
                    border: none;
                }
                
                .phone-home-indicator {
                    position: absolute;
                    bottom: 10px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 100px;
                    height: 5px;
                    background: rgba(0, 0, 0, 0.3);
                    border-radius: 3px;
                    z-index: 10;
                }
                
                .phone-shadow {
                    position: absolute;
                    top: 10px;
                    left: 10px;
                    width: calc(100% - 20px);
                    height: calc(100% - 20px);
                    border-radius: 40px;
                    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);
                    z-index: -1;
                }
            `}</style>
        </section>
    );
};

export default Demo;
